module.exports = __webpack_public_path__ + "img/logo.818e2b5f.png";